module.exports = __webpack_public_path__ + "img/play.bfc1a275.svg";